import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { MenuItem } from "../../menu-item";

import "./menu-group.m.css";

const MenuGroup = () => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const menus = get(qtState, ["data", "navigationMenu", "footer"], []);
  const [currentPath, setCurrentPath] = useState("");
  const [secondaryMenu, setSecondaryMenu] = useState(false);
  const [currentMenuId, setCurrentMenuId] = useState("");
  const [isDesktop, setIsDesktop] = useState(null);

  // To Handle secondary menu when navigated to other page
  useEffect(() => {
    if (currentPath !== qtState.currentPath) {
      setCurrentPath(qtState.currentPath);
      setCurrentMenuId("");
      setSecondaryMenu(false);
    }
    if (global.deviceWidth > 1024) {
      setIsDesktop(true);
    }
  }, []);

  // To handle Secondary menu
  const toggleHandler = (id) => {
    if (id === currentMenuId) setCurrentMenuId("");
    else setCurrentMenuId(id);
    setSecondaryMenu(!secondaryMenu);
  };

  const showSecondaryMenu = (id) => (isDesktop || currentMenuId === id ? "block" : "none");

  const upChevron = {
    display: "flex",
    alignSelf: "flex-start",
    transform: "rotate(180deg)",
  };

  const downChevron = {
    transform: "rotate(0deg)",
  };

  if (!menus) {
    return null;
  }

  return menus.map(
    ({ title, children, id }, i) =>
      children &&
      children.length > 0 && (
        <div styleName="menu-group" key={i}>
          <div>
            <h6 key={i} styleName="title">
              {title}
            </h6>
            <ul style={{ display: showSecondaryMenu(id) }}>
              {children &&
                children.slice(0, 10).map((item, id) => (
                  <li styleName="list-item" key={id}>
                    <MenuItem
                      key={id}
                      item={item}
                      menuStyle="menu-items-footer"
                      toggleHandler={() => toggleHandler(id)}
                    />
                  </li>
                ))}
            </ul>
          </div>
          <button
            styleName="chevron"
            style={currentMenuId === id ? upChevron : downChevron}
            onClick={() => toggleHandler(id)}
            aria-label="chevron"
          >
            <SvgIconHandler
              className="down-chevron-wrapper"
              type="down-chevron"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            />
          </button>
        </div>
      )
  );
};

export { MenuGroup };
